import { useSelector } from 'react-redux';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { ImageZoomFull } from '../../../components/imageZoom/ImageZoomFull';
import { Avatar } from '../../../components/avatar';
import { MessageMenuMuro } from './MessageMenuMuro';
import { formatDateTime } from '../../../common/formatDateText';
import { capitalizarPalabras } from '../../../common/upperCaseWord';

const relativeNoticeTime = (date) => {
    if (!date) return '';
    const then = new Date(date).getTime();
    if (Number.isNaN(then)) return '';

    const diffMs = Date.now() - then;
    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1) return 'Ahora';
    if (minutes < 60) return `Hace ${minutes} min`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `Hace ${hours} h`;

    const days = Math.floor(hours / 24);
    if (days === 1) return 'Ayer';
    if (days < 7) return `Hace ${days} días`;

    return new Intl.DateTimeFormat('es-MX', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    }).format(new Date(date));
};

export const CardNoticeMessage = ({
    notice,
    canManage = false,
    onEdit,
}) => {
    const { user } = useSelector((state) => state.user);
    const userId = user?._id;
    const {
        _id: messaageMuroId,
        urlName,
        message,
        createdBy,
        createdAt,
        link,
    } = notice || {};

    const firstName = createdBy?.firstName || '';
    const lastName = createdBy?.lastName || '';
    const authorName = capitalizarPalabras(`${firstName} ${lastName}`.trim()) || 'Participante';
    const isAuthor = userId && createdBy?._id && String(userId) === String(createdBy._id);
    const showMenu = canManage || isAuthor;
    const absoluteTime = formatDateTime(createdAt);
    const relativeTime = relativeNoticeTime(createdAt);

    return (
        <article className="notice-card">
            {urlName ? (
                <div className="notice-card__media">
                    <ImageZoomFull
                        imageUrl={urlName}
                        alt={`Imagen del aviso de ${authorName}`}
                        className="notice-card__image"
                    />
                </div>
            ) : null}

            <div className="notice-card__body">
                <header className="notice-card__header">
                    <div className="notice-card__author">
                        <Avatar
                            name={authorName}
                            size="md"
                            className="notice-card__avatar"
                        />
                        <div className="notice-card__author-meta min-w-0">
                            <p className="notice-card__author-name">{authorName}</p>
                            <time
                                className="notice-card__time"
                                dateTime={createdAt ? new Date(createdAt).toISOString() : undefined}
                                title={absoluteTime}
                            >
                                {relativeTime || absoluteTime}
                            </time>
                        </div>
                    </div>
                    {showMenu ? (
                        <MessageMenuMuro
                            messaageMuroId={messaageMuroId}
                            canEdit={Boolean(canManage && onEdit)}
                            onEdit={onEdit}
                        />
                    ) : null}
                </header>

                {message ? (
                    <p className="notice-card__message">{message}</p>
                ) : null}

                {link ? (
                    <a
                        className="notice-card__link"
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        title={link}
                    >
                        <span className="notice-card__link-text">{link}</span>
                        <ArrowTopRightOnSquareIcon
                            className="notice-card__link-icon"
                            aria-hidden="true"
                        />
                        <span className="sr-only"> (se abre en una pestaña nueva)</span>
                    </a>
                ) : null}
            </div>
        </article>
    );
};
